import { useQuery } from '@tanstack/react-query'
import { GrowthService } from '@mc/api'

const staleTime = 1000 * 60 * 60 // 1 hour

export const useGrowthContent = () =>
  useQuery({
    queryKey: ['growth-content'],
    queryFn: () => GrowthService.getGrowthContent(),
    staleTime,
  })
